<template>
  <modal :closeModal="() => false" :backText="''">
    <div class="unmatched-modal">
      <header>
        <h1 class="unmatched-modal__title">
          {{ $t('session.unMatchedModal.title') }}
        </h1>
      </header>

      <h2 class="unmatched-modal__subtitle">
        {{ $t('session.unMatchedModal.subtitle') }}
      </h2>

      <separator />

      <footer class="unmatched-modal__footer">
        <div class="unmatched-modal__buttons">
          <large-button primary @click.native="end">{{
            $t('session.unMatchedModal.buttonText')
          }}</large-button>
        </div>
      </footer>
    </div>
  </modal>
</template>

<script>
import { mapGetters } from 'vuex'
import NetworkService from '@/services/NetworkService'
import AnalyticsService from '@/services/AnalyticsService'
import { EVENTS } from '@/consts'
import Modal from '@/components/Modal.vue'
import Separator from '@/components/Separator.vue'
import LargeButton from '@/components/LargeButton.vue'
import i18n from '@/i18n'

export default {
  name: 'UnmatchedModal',
  components: { LargeButton, Modal, Separator },
  props: {
    sessionId: { type: String, required: true },
  },
  computed: {
    ...mapGetters({ mobileMode: 'app/mobileMode' }),
  },
  mounted() {
    // Session toggle buttons are rendered on a higher stacking context
    // than this modal in mobile. Hide the buttons when mounted
    if (this.mobileMode) {
      const sessionToggleButtons = Array.from(
        document.querySelectorAll('.toggleButton')
      )
      for (const element of sessionToggleButtons) {
        element.style.position = 'static'
      }
    }
  },
  methods: {
    async end() {
      const data = {
        timeout: 45,
      }
      await NetworkService.timedOutSession(this.sessionId, data)
      AnalyticsService.captureEvent(EVENTS.SESSION_TIMED_OUT_45_MINS, {
        event: EVENTS.SESSION_TIMED_OUT_45_MINS,
      })
      this.$router.push(`/${i18n.locale}/dashboard`)
    },
  },
}
</script>

<style lang="scss" scoped>
.unmatched-modal {
  @include flex-container(column);

  &__title {
    @include font-category('display-small');
  }

  &__subtitle {
    @include font-category('body');
    margin: 0 0 35px;
    color: $c-secondary-grey;
    font-size: 15px;
  }

  &__buttons {
    margin-top: 16px;
    @include flex-container(row, flex-end);
    @include child-spacing(left, 16px);
  }
}

html.is-rtl {
  .unmatched-modal {
    &__buttons {
      @include child-spacing-rtl(left, 16px);
    }
  }
}
</style>
